import { generateId } from '@domgen/dgx-fe-common';
import { CountryIso3Code } from '@domgen/dgx-fe-i18n';
import {
  CheckoutItem,
  CheckoutPerson,
  CheckoutRequest,
  CustomerDetails,
  RegisteredItem,
  RegisteredItemProductDetails,
} from '@us-registration/util-models';

export function getCheckoutURLPayload(
  customerDetails: CustomerDetails,
  registeredItem: RegisteredItem,
  retailerDomain: string,
  promotionalPriceEnabled: boolean,
  systemCode: string,
  clickedPrepayCta: boolean,
  registeredItemAnnualProductDetails?: RegisteredItemProductDetails
): CheckoutRequest {
  const region = customerDetails.billingAddress.state;

  const payload: CheckoutRequest = {
    ...(promotionalPriceEnabled &&
      registeredItem.products[0].discountDetails && {
        overrideAchDiscountCode:
          registeredItem.products[0].discountDetails.discountAchCode,
      }),
    ...(promotionalPriceEnabled &&
      registeredItem.products[0].discountDetails && {
        overrideCCDiscountCode:
          registeredItem.products[0].discountDetails.discountCcCode,
      }),
    ...(clickedPrepayCta && {
      prepayMonths: registeredItemAnnualProductDetails?.prepayMonths,
    }),
    ...(clickedPrepayCta && {
      prepayGrossAmount: registeredItemAnnualProductDetails?.price,
    }),
    retailerDomain: retailerDomain,
    payload: {
      businessEventCode: 'COCRE',
      businessSource: 'WEB',
      channelCode: 'DGOLR',
      clientCode: 'WHIRL',
      contract: {
        attributes: [
          {
            itemIterationId: 1,
            netAmount: registeredItem.standardPremium,
            periodOfCover: 12,
            effectiveDate: registeredItem.effectiveDate,
          },
        ],
        isMultiplan: false,
      },
      interactionId: generateId(),
      item: formatRegistrationDataToCheckoutItem(
        customerDetails,
        registeredItem,
        region
      ),
      journeyCode: 'REG',
      person: formatCustomerDetailsToCheckoutPerson(customerDetails, region),
      quoteId: registeredItem.Id,
      systemCode,
      userId: 'USOLR',
    },
  };

  return payload;
}

export function formatRegistrationDataToCheckoutItem(
  customerDetails: CustomerDetails,
  registeredItem: RegisteredItem,
  region?: string
): CheckoutItem[] {
  return [
    {
      itemIterationId: 1,
      item: {
        itemTypeCode: registeredItem.appliances[0].type,
        manufacturerBrandCode: registeredItem.merchandiseBrand,
        serialNumber: registeredItem.appliances[0].serialNumber as string,
        modelNumber: registeredItem.appliances[0].modelNumber as string,
        operationalStatusCode: 'W',
        purchase: {
          price: Number(registeredItem.appliances[0].purchasePrice),
          currencyCode: 'USD',
          date: registeredItem.appliances[0].purchaseDate as string,
          retailer: registeredItem.appliances[0].purchaseFrom || 'Whirlpool',
        },
        address: [
          {
            addressCategoryCode: 'BIL',
            addressLine1: customerDetails.billingAddress.line1,
            addressLine2: customerDetails.billingAddress.line2 as string,
            addressLine3: customerDetails.billingAddress.city as string,
            postalCode: customerDetails.billingAddress.postalCode,
            region: region as string,
            countryCode: CountryIso3Code.UnitedStates,
            addressOverride: false,
          },
        ],
      },
    },
  ];
}

export function formatCustomerDetailsToCheckoutPerson(
  customerDetails: CustomerDetails,
  region?: string
): CheckoutPerson {
  return {
    firstName: customerDetails.firstName as string,
    surname: customerDetails.lastName as string,
    phone: [
      {
        type: 'L',
        usage: 'PER',
        value:
          customerDetails.phone.Home ||
          customerDetails.phone.work ||
          customerDetails.phone.other ||
          '',
        preferred: true,
      },
    ],
    email: [
      {
        usage: 'PER',
        value: customerDetails.email as string,
        preferred: true,
      },
    ],
    address: [
      {
        addressCategoryCode: 'BIL',
        addressLine1: customerDetails.billingAddress.line1,
        addressLine2: customerDetails.billingAddress.line2 as string,
        addressLine3: customerDetails.billingAddress.city as string,
        postalCode: customerDetails.billingAddress.postalCode,
        region: region as string,
        countryCode: CountryIso3Code.UnitedStates,
        addressOverride: false,
      },
    ],
  };
}
